<template>
    <app-button
        small
        secondary
        :color="color"
        :title="$t('go_back')"
        :text="$t(text)"
        icon-left="prev"
        :to="to"
        @click.prevent="onButtonClick(force)"
    />
</template>

<script>
import goBack from '@/router/lib/goBack';

export default {
    name: 'AppBackButton',
    props: {
        color: {
            type: String,
            default: 'primaryText'
        },
        text: {
            type: String,
            default: 'back'
        },
        force: {
            type: Boolean,
            default: false
        },
        to: {
            type: [Object, String],
            default: null
        }
    },
    methods: {
        onButtonClick(force) {
            if (!this.to) {
                goBack(force);
            }
        }
    }
};
</script>
